var _circle, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMaxBotCircle = function SvgMaxBotCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_19563_40381_clip_path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.00866138 0.00790369 -0.00824647 0.00830135 12 12)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 2900.24,
    height: 2900.24,
    x: -1450.12,
    y: -1450.12
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(133, 38, 209, 1) 0deg,rgba(0, 204, 255, 1) 84.6deg,rgba(0, 38, 255, 1) 180deg,rgba(165, 0, 198, 1) 340.069deg,rgba(133, 38, 209, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 12.5,
    r: 5.5,
    fill: "#3356EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M18.9989 11.5935C18.9963 11.511 18.986 11.431 18.9783 11.351C18.8243 9.72579 18.2056 8.29918 17.0785 7.12538C15.5535 5.53882 13.6717 4.84744 11.4895 5.02802C9.64361 5.18281 8.06986 5.94384 6.80674 7.31628C5.68997 8.52877 5.10206 9.97603 5.01477 11.6219C4.96599 12.5377 5.03787 13.451 5.23299 14.3487C5.39216 15.0866 5.58728 15.8166 5.76442 16.5519C5.90305 17.1246 6.00831 17.7024 6.01088 18.2932C6.01345 18.7034 6.26504 18.982 6.67068 18.9975C7.5564 19.0336 8.29065 18.6776 8.91963 18.0791C9.01719 17.9862 9.06854 17.9862 9.1738 18.0533C9.46133 18.239 9.74887 18.4274 10.0492 18.5847C10.5396 18.8375 11.0736 18.9253 11.6204 18.9588C12.6114 19.0207 13.5742 18.902 14.5035 18.5512C17.2377 17.5193 19.004 14.9524 18.9989 12.0192C18.9989 11.8773 19.0014 11.7354 18.9989 11.5935ZM13.7025 15.1227C12.9015 15.5406 12.062 15.6851 11.1866 15.4219C10.8682 15.3265 10.5678 15.1562 10.2675 15.0092C10.175 14.9627 10.1263 14.9627 10.0467 15.0298C9.85927 15.1923 9.66672 15.3497 9.46133 15.4864C9.19947 15.6593 9.07367 15.6206 8.9299 15.342C8.71682 14.9369 8.62183 14.4958 8.56021 14.0495C8.50116 13.6264 8.47549 13.1956 8.43441 12.7699C8.45495 11.9521 8.56278 11.155 8.93247 10.4172C9.52295 9.23305 10.4574 8.52877 11.7924 8.4359C13.7154 8.30175 15.4329 9.77996 15.5972 11.7019C15.7153 13.0898 14.9554 14.47 13.7025 15.1227Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_19563_40381_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11
  })))));
};
export default SvgMaxBotCircle;